import { useCallback, useState } from 'react';

/**
 * Interrupteur admin du Feed (« Tout le monde », migration 0347) : mémorisé
 * sur l'APPAREIL. localStorage peut être inaccessible (navigation privée) :
 * l'interrupteur marche alors sans mémoire.
 */
export const ADMIN_FEED_ALL_KEY = 'jr_admin_feed_all';

export function readAdminFeedAll(): boolean {
  try {
    return localStorage.getItem(ADMIN_FEED_ALL_KEY) === '1';
  } catch {
    return false;
  }
}

export function useAdminFeedAll(): [boolean, (next: boolean) => void] {
  const [value, setValue] = useState(readAdminFeedAll);
  const set = useCallback((next: boolean) => {
    setValue(next);
    try {
      if (next) localStorage.setItem(ADMIN_FEED_ALL_KEY, '1');
      else localStorage.removeItem(ADMIN_FEED_ALL_KEY);
    } catch {
      /* sans mémoire */
    }
  }, []);
  return [value, set];
}
